module.exports = __webpack_public_path__ + "img/manage-promotion.7e7c06d5.png";